import {
    GET_RESUMEN_INTERCIA,
    SET_FILTROS_INTERCIA
} from '../types';


// 🔴 Drop 2026-09-22 (RG-541): el período deja de ser un rango de meses y pasa a ser una fecha
// exacta — `fechaDesde`/`fechaHasta` (YYYY-MM-DD), sin depender de `meses-disponibles`.
const estadoInicial = {
    resumen: null,
    queryResumen: null, // query (base64) con la que se cargó `resumen`; la usa la exportación de casos
    filtros: {
        compania: '',
        fechaDesde: '',
        fechaHasta: ''
    }
};

export default function dashboardInterciaReducer(state = estadoInicial, action) {
    switch (action.type) {
        case GET_RESUMEN_INTERCIA:
            return {
                ...state,
                resumen: action.error ? null : action.payload,
                queryResumen: action.error ? null : (action.meta?.query ?? null)
            }
        case SET_FILTROS_INTERCIA:
            return { ...state, filtros: { ...state.filtros, ...action.payload } }
        default:
            return state
    }
}
